import React, { useState, useCallback, memo } from 'react';
import { navigate } from 'gatsby';
import { IoSearchSharp } from 'react-icons/io5';
import { buildQuerySearchPath } from '@src/utils/searchQueryFilters';
import * as styles from './SearchForm.module.css';

const ResourceSearchForm = memo(() => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchSubmit = useCallback(
    (e) => {
      e.preventDefault();
      navigate(buildQuerySearchPath(searchQuery));
    },
    [searchQuery],
  );

  const handleInputChange = useCallback((e) => {
    setSearchQuery(e.target.value);
  }, []);

  return (
    <form onSubmit={handleSearchSubmit} className={styles.resourceSearchForm}>
      <div className={styles.searchInputContainer}>
        <IoSearchSharp size={20} className={styles.searchIcon} />
        <input
          type="text"
          value={searchQuery}
          onChange={handleInputChange}
          placeholder="Search for resources..."
          className={styles.searchInput}
        />
        <button type="submit" className={styles.searchSubmitBtn}>
          Search
        </button>
      </div>
    </form>
  );
});

export default ResourceSearchForm;
